import './ValidatedParameter.scss';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IParameterNumeric } from '../helpers/parameters.helpers';
import { ValidatedTextInput } from './ValidatedTextInput';

interface IProps {
  parameter: IParameterNumeric;
  fieldIndex: number;
  value: string;
  alwaysShowError?: boolean;
  disabled?: boolean;
  error?: {
    message: TranslationKey;
    messageParameters?: Record<string, string | number>;
  } | null;
  onChange: (value: string) => void;
  onBlur: (value: string) => void;
}

export const ValidatedNumericParameter = observer((props: IProps): ReactElement => {
  const { parameter, fieldIndex, error, disabled, onChange, onBlur, alwaysShowError, value } = props;
  const { t } = useTranslator();

  const isFieldValidated = error !== undefined || alwaysShowError;
  const hasError = !!error;

  const {
    label: parameterLabel,
    config: { min, max, step },
    itemDescription,
  } = parameter;

  return (
    <div className={`list-row ${fieldIndex === 0 ? 'first' : ''}`}>
      <div className='left training-failure-reason'>
        {itemDescription?.displayedName ?? itemDescription?.shortName ?? t(`params.${parameterLabel}`)}
        {!!itemDescription?.description && (
          <FontAwesomeIcon
            icon={faInfoCircle}
            title={itemDescription.description}
          />
        )}
      </div>
      <div className='right right-form'>
        <ValidatedTextInput
          id={`model-${parameterLabel}-numeric-field`}
          className='parameter-input'
          type='number'
          min={min}
          max={max}
          step={step}
          isValid={isFieldValidated ? !hasError : undefined}
          feedbacks={hasError ? [error.message] : []}
          feedbacksParams={hasError ? error.messageParameters : {}}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onBlur={onBlur}
        />
      </div>
    </div>
  );
});
